// Product/Feature name and icon

import { classNames } from "./library/utils/classNames";
import {
  LissajousActiveLearning,
  LissajousActiveTesting,
  LissajousAnnotationTeams,
  LissajousAutoTrain,
  LissajousDataDebugger,
  LissajousHITL,
  LissajousInference,
  LissajousMonitoring,
  LissajousProgrammatic,
  LissajousSize,
} from "./Lissajous";

export interface LogoProps {
  size?: LissajousSize;
  noIcon?: boolean;
}

const BaseLogo = ({
  name,
  Icon,
  size = 24,
  noIcon,
}: {
  name: string;
  Icon: React.ComponentType<{ className: string; size: LissajousSize }>;
} & LogoProps) => {
  let textSize;

  switch (size) {
    case 16:
      textSize = "text-13-16 lg:text-14-16";
      break;
    case 20:
      textSize = "text-14-20 lg:text-16-20";
      break;
    case 24:
    default:
      textSize = "text-14-24 lg:text-16-24";
      break;
  }

  return (
    <div className="flex items-center gap-8">
      {!noIcon && Icon && <Icon className="shrink-0" size={size} />}
      <div className={classNames(textSize, "truncate font-bold")}>{name}</div>
    </div>
  );
};

export const ProgrammaticLogo = (props: LogoProps) => (
  <BaseLogo
    name="Programmatic"
    Icon={(props) => <LissajousProgrammatic {...props} />}
    {...props}
  />
);

export const AnnotationTeamsLogo = (props: LogoProps) => (
  <BaseLogo
    name="Annotation Teams"
    Icon={(props) => <LissajousAnnotationTeams {...props} />}
    {...props}
  />
);

export const ActiveLearningLogo = (props: LogoProps) => (
  <BaseLogo
    name="Active Learning"
    Icon={(props) => <LissajousActiveLearning {...props} />}
    {...props}
  />
);

export const HumanInTheLoopDeploymentLogo = (props: LogoProps) => (
  <BaseLogo
    name="Human-in-the-loop deployment"
    Icon={(props) => <LissajousHITL {...props} />}
    {...props}
  />
);

export const AutoTrainLogo = (props: LogoProps) => (
  <BaseLogo
    name="Auto Train"
    Icon={(props) => <LissajousAutoTrain {...props} />}
    {...props}
  />
);
export const InferenceLogo = (props: LogoProps) => (
  <BaseLogo
    name="Inference"
    Icon={(props) => <LissajousInference {...props} />}
    {...props}
  />
);
export const ActiveTestingLogo = (props: LogoProps) => (
  <BaseLogo
    name="Active Testing"
    Icon={(props) => <LissajousActiveTesting {...props} />}
    {...props}
  />
);
export const DataDebuggerLogo = (props: LogoProps) => (
  <BaseLogo
    name="Data Debugger"
    Icon={(props) => <LissajousDataDebugger {...props} />}
    {...props}
  />
);
export const MonitoringLogo = (props: LogoProps) => (
  <BaseLogo
    name="Monitoring"
    Icon={(props) => <LissajousMonitoring {...props} />}
    {...props}
  />
);

export const enum Products {
  Programmatic = "Programmatic",
  ActiveLearning = "Active Learning",
  AnnotationTeams = "Annotation Teams",
  Evaluate = "Evaluate",
  Deploy = "Deploy",
}
